import { Input } from '@builder.io/sdk';

const dashboardBackdropFields = [
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Get a Demo',
    helperText: 'Heading shown on the left side of the focal card. Leave blank to render the form/children full-width.',
  },
  {
    name: 'seoHeading',
    type: 'string',
    helperText:
      'Only used when Heading is blank: rendered as a visually hidden H1 so search engines get a real page heading without changing the layout (e.g. on the free trial page).',
  },
  {
    name: 'subheading',
    type: 'richText',
    defaultValue:
      "<p>Ready to see how Prismatic can help? If you're a B2B software company building customer-facing integrations as part of your product offering, tell us about your goals.</p>",
    helperText: 'Description shown under the heading. Supports bold, italic, links, and line breaks.',
  },
  {
    name: 'marketoForm',
    type: 'reference',
    model: 'marketo-forms',
    helperText:
      'Optional Marketo form rendered on the right side of the focal card. If empty, the right side renders any Builder blocks dropped as children.',
  },
] as const satisfies DeepReadonly<Input[]>;

const dashboardBackdropConfig = {
  name: 'DashboardBackdrop',
  inputs: dashboardBackdropFields,
  canHaveChildren: true,
  defaultStyles: {
    minHeight: '100dvh',
    paddingTop: '0',
    paddingBottom: '0',
  },
};

export type DashboardBackdropProps = GenerateBuilder<typeof dashboardBackdropFields>;

export default dashboardBackdropConfig;
